import { render } from "./StockDetail.vue?vue&type=template&id=b8960ab6"
import script from "./StockDetail.vue?vue&type=script&lang=js"
export * from "./StockDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__